import { Controller, useForm, type SubmitHandler } from "react-hook-form"
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'

import Form from "@/components/forms/reusables/form"
import useFormStates from "@/hooks/use-form-states"
import type { MunicipalityAdministrationListItem, MunicipalityScore, MunicipalityScoreVisibilityFormInput } from "@/types"
import { useSetMunicipalityScoreVisibility } from "@/hooks/api/use-municipality-scores"

const MunicipalityScoreVisibilityForm = ({
    municipalityId,
    municipalityScore,
    closeCallback,
} : {
    municipalityId: number,
    municipalityScore: MunicipalityAdministrationListItem["municipality_score"],
    closeCallback?: () => void,
}) => {

    const initialValues: MunicipalityScoreVisibilityFormInput = {
        visible: !!municipalityScore.visible,
    }
    
    const {
        control,
        handleSubmit,
        formState: { isDirty },
        reset,
        watch,
    } = useForm({
        defaultValues: { ...initialValues },
    })

    const {
        resetWithVersion,
        requestInProgress,
        setRequestInProgress,
    } = useFormStates(() => reset(initialValues))

    const mutation = useSetMunicipalityScoreVisibility(
        municipalityId,
        {
            setRequestInProgress,
            onSuccessCallback: closeCallback,
        },
    )

    const onSubmit: SubmitHandler<MunicipalityScoreVisibilityFormInput> = data => {
        setRequestInProgress(true)
        mutation.mutate(data)
    }

    const newVisible = watch('visible')

    return (
        <Form
            onSubmit={handleSubmit(onSubmit)}
            closeCallback={closeCallback}
            isLoadedFromLocalStorage={false}
            isDirty={isDirty}
            resetWithVersion={resetWithVersion}
            requestInProgress={requestInProgress}
            buttonText="Upravit"
            heading="Upravit zobrazení skóre obce na titulní straně"
            disableSave={!!municipalityScore.visible === newVisible}
        >
            <Box mx="auto" mb={1}>
                <FormControlLabel control={
                    <Controller
                        name="visible"
                        control={control}
                        render={({ field }) => <Switch
                            {...field}
                            value={!!field.value}
                            checked={!!field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                        />}
                    />
                } label="Skóre obce se zobrazuje na titulní straně" />
            </Box>
        </Form>
    )
}

export default MunicipalityScoreVisibilityForm
